import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import MainLayout from '../../mainLayout';
import styled, {useTheme} from 'styled-components/native';
import {
  BackHandler,
  Keyboard,
  LayoutChangeEvent,
  Platform,
  RefreshControl,
  View,
} from 'react-native';
import {Theme} from '../../../theme/lightTheme';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {hdp, wdp} from '../../../utils/responsive';
import TextGeneric from '../../../components/textGeneric';
import {RootState} from '../../../redux/store';
import {connect, useDispatch, useSelector} from 'react-redux';
import {LatestScreenProps} from '../../../interfaces/screens/latest';
import Animated, {
  FadeIn,
  FadeInDown,
  FadeInUp,
  FadeOut,
  FadeOutDown,
  FadeOutUp,
} from 'react-native-reanimated';
import {DrugItemDetailsType, DrugItemType} from '../../../interfaces/api/tabs';
import {getNews} from '../tabNews/actions';
import DrugFilterItem from '../../../components/drugFilterItem';
import {staticDrugsFilters} from '../../../assets/static/drugs';
import {getDrugDetails} from './actions';
import DrugItem from '../../../components/drugItem';
import SkeletonPlaceholder from '../../../components/skeletonPlaceholder';
import Icon from '../../../components/icon';
import {
  getFontFamily,
  getHomeTabItemById,
  requestMicrophonePermission,
} from '../../../utils/helpers';
import AnswerItem from '../../../components/answerItem';
import {FlatList} from 'react-native-gesture-handler';
import {tr} from '../../../translations';
import userVoice from '../../../utils/services/userVoice';
import Voice from '@react-native-voice/voice';
import {setIsTabVoiceInteractionPlayed} from '../settings/reducer';
import {
  SpeechErrorEvent,
  SpeechResultsEvent,
} from '@react-native-voice/voice/src/VoiceModuleTypes';
import {useFocusEffect} from '@react-navigation/native';
import {analyticsService} from '../../../utils/services/analytics';
import {AnalyticsEvents, ChatType, TabIds} from '../../../utils/enums';
import GenericButton from '../../../components/button';
import Loader from '../../../components/loader';
import EmptyList from '../../../components/emptyList';
import DrugSearchListSkeleton from '../../../components/drugSearchListSkeleton';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';
import BackIcon from '../../../components/header/backIcon';
import MenuIcon from '../../../components/header/menuIcon';
import {
  HeaderBackground,
  HeaderContainer,
  HeaderContentContainer,
} from '../../../components/header';
import Markdown from '@ronradtke/react-native-markdown-display';
import {
  cleanAndFormatMarkdown,
  markdownRules,
  markdownStyle,
  openMDLink,
} from '../../../utils/markdownHelpers';
import ChatFooter from '../../../components/chat/chatFooter';
import {resetChat, sendMessage} from '../chat/actions';
import screens from '../../../config/screens';
import GenioLatestNews from '../../../components/genioLatestNews';
import SearchBar from '../../../components/searchBar';
import CircleRecordingView from '../../../components/circleRecordingView';
import {useCustomHeaderHeight} from '../../../utils/hooks/useHeaderHeight';
import {Space} from '../home';
import {FilterType} from '../../../interfaces/reducers/homeState';
import {TibButton} from '../../../components/tibButton';
import '../../../utils/webAnimations';

const Container = styled.View`
  width: 100%;
  height: 100%;
`;
const ContentContainer = styled(KeyboardAwareScrollView)`
  width: 100%;
  height: 100%;
`;
export const FiltersContainer = styled(Animated.View)`
  width: ${wdp(94)}px;
  align-self: center;
  background-color: ${({theme}) => theme.cardBackground};
  border-radius: 40px;
  z-index: 22;
  margin-top: ${({theme}) => theme.text.s12}px;
`;
const DrugDetailsFragment = styled(Animated.View)`
  width: ${wdp(94)}px;
  align-self: center;
  background-color: ${({theme}) => theme.cardBackground};
  border-radius: 16px;
  margin-top: ${hdp(3)}px;
  padding: ${hdp(2)}px 5% ${hdp(4)}px 5%;
  justify-content: center;
`;
const DrugDetailsContainer = styled.View`
  width: ${wdp(85)}px;
  align-self: center;
  border-radius: 50px;
  z-index: 1;
  align-items: center;
  justify-content: center;
`;
const CloseDrugsIconContainer = styled.TouchableOpacity`
  position: absolute;
  top: ${({theme}) => theme.text.s55 / 2}px;
  right: -${({theme}) => theme.text.s55 / 2}px;
  z-index: 99;
  background-color: ${({theme}) => theme.secondary + '22'};
  padding: ${({theme}) => theme.text.s55 / 2}px;
  border-radius: 100px;
`;
const HeaderSearchBarContainer = styled.View`
  width: ${({theme}) => wdp(90) - theme.text.s3 * 3}px;
  height: 90%;
  align-self: center;
  z-index: 2;
`;
const SearchOverlay = styled(Animated.View)<any>`
  width: ${hdp(300)}px;
  height: ${hdp(300)}px;
  border-radius: ${hdp(300)}px;
  background-color: ${({isVisible}) =>
    isVisible ? 'rgba(0, 0, 0, 0.3)' : 'transparent'};
  z-index: 1;
  position: absolute;
  top: -${hdp(150)}px;
  left: -${hdp(150)}px;
`;
const HeaderSearchBar = styled(SearchBar)`
  width: 100%;
  height: 95%;
  align-self: center;
  background-color: ${({theme}) => theme.homeBackground};
`;
export const FilterItemContainer = styled(Animated.View)`
  width: ${wdp(90)}px;
  align-self: center;
  padding-vertical: ${({theme}) => theme.text.s12}px;
  z-index: 2;
`;
export const FilterValuesContainer = styled.View`
  width: 100%;
  align-self: center;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
`;
export const FilterLabel = styled(TextGeneric)`
  font-size: ${({theme}) => theme.text.s6 + 1}px;
  color: ${({theme}) => theme.text.title};
  letter-spacing: 1px;
  padding-vertical: 4%;
  text-align: center;
  text-shadow-color: ${({theme}) => theme.text.title + '55'};
  text-shadow-offset: 0 2px;
  text-shadow-radius: 5px;
  width: 77%;
  align-self: center;
`;
const CloseAnswerIconContainer = styled.View`
  align-self: flex-end;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 99;
`;
const SearchContainer = styled(Animated.View)`
  width: 100%;
  height: ${hdp(50)}px;
  position: absolute;
  top: 70%;
  align-self: center;
  z-index: 1;
`;
const SearchContentContainer = styled.View`
  width: 100%;
  min-height: ${hdp(10)}px;
  max-height: ${hdp(70)}px;
  background-color: ${({theme}) => theme.text.greyLight};
  align-self: center;
  border-radius: 8px;
`;
const SearchResultText = styled(TextGeneric)`
  font-size: ${({theme}) => theme.text.s8}px;
  color: ${({theme, isSelected}) =>
    isSelected ? theme.text.light : theme.text.title};
`;
const SearchResultItem = styled.TouchableOpacity<any>`
  padding: 5%;
  width: 90%;
  align-self: center;
  background-color: ${({theme, isSelected}) =>
    isSelected ? theme.primary + '99' : 'transparent'};
  margin-bottom: 2%;
  border-radius: 8px;
`;
const ConfirmSelection = styled(GenericButton)`
  align-self: center;
  padding: 2px;
  margin-vertical: 3%;
`;
const EmptyContainer = styled.View`
  align-items: center;
  justify-content: center;
  height: ${hdp(30)}px;
`;
const EmptyText = styled(TextGeneric)`
  font-size: ${({theme}) => theme.text.s8}px;
  color: ${({theme}) => theme.text.dark};
  width: 80%;
  padding-vertical: 4%;
  text-align: center;
`;
const TipModalContainer = styled.View`
  z-index: 99999;
`;

/**
 * Latest screen component.
 *
 * @param {LatestScreenProps} props - The screen component props.
 * @param {object} props.navigation - The navigation object.
 */
const Drugs: React.FC<LatestScreenProps> = ({
                                              navigation,
                                              route,
                                              auth,
                                            }: LatestScreenProps) => {
  const pageSize = 30;
  const theme = useTheme() as Theme;
  const {language} = useSelector((state: RootState) => state.lang);
  const {languageCode, countryCode} = language || {};
  const {currentUser} = auth || {};
  const {bottom: bottomInset, top: topInset} = useSafeAreaInsets();
  const headerHeight = useCustomHeaderHeight();
  const {tab_name: tabName, isDiseases} = route?.params || {};
  const tabId = isDiseases ? TabIds.Diseases : TabIds.Drugs;
  const {filters} = getHomeTabItemById(tabId);

  const [filtersResult, setFiltersResult] = useState<any>({});
  const tabFilters = filters
    ? filters.filter(i => i.key === 'letter_id')
    : staticDrugsFilters;
  ////////
  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [page, setPage] = useState(1);
  const [isLastPage, setIsLastPage] = useState<boolean>(false);
  const [selectedDrug, setSelectedDrug] = useState<any>({});
  const [isFilterModalShouldClose, setIsFilterModalShouldClose] =
    useState<any>(false);
  // selected drug item Details
  const [isDrugDetailsLoading, setIsDrugDetailsLoading] = useState(false);
  const [isDrugDetailsError, setIsDrugDetailsError] = useState(false);
  const [drugDetailsData, setDrugDetailsData] = useState<DrugItemDetailsType[]>(
    [],
  );
  const [drugDetailsSection, setDrugDetailsSection] = useState<any>(null);
  const scrollViewRef = useRef<KeyboardAwareScrollView>(null);
  //search
  const [search, setSearch] = useState<any>(null);
  const [selectedDrugSearch, setSelectedDrugSearch] = useState<any>({});
  // recording
  const [isRecording, setIsRecording] = useState(false);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const entryTime = useRef(new Date());
  const {isTabVoicePlayed} = useSelector((state: RootState) => state.settings);
  const dispatch = useDispatch();
  const [height, setHeight] = useState(0);
  const [isTipVisible, setIsTipVisible] = useState(false);
  const findHeight = (event: LayoutChangeEvent) => {
    setHeight(event.nativeEvent.layout.height);
  };
  const [scrollEnabled, setScrollEnabled] = useState(true);

  // Handle back button press
  const handleBackPress = useCallback(() => {
    if (drugDetailsSection) {
      setDrugDetailsSection(null);
      return true;
    }
    const drugItem = Object.values(selectedDrug || {})[0] as DrugItemType;
    if (!scrollEnabled || drugItem || drugDetailsSection) {
      setSelectedDrug({});
      setDrugDetailsSection(null);
      setIsFilterModalShouldClose(true);
    } else {
      navigation?.goBack();
    }
    return true;
  }, [selectedDrug, scrollEnabled, drugDetailsSection]);

  // Set up the back button listener
  useEffect(() => {
    if (Platform.OS !== 'web') {
      const subscription = BackHandler.addEventListener(
        'hardwareBackPress',
        handleBackPress,
      );

      return () => {
        subscription.remove();
      };
    }
  }, [handleBackPress]);

  const loadMore = async (refresh = false) => {
    if (isLoading && !refresh) {
      return;
    }
    setIsError(false);
    if (!isLastPage || refresh) {
      if (refresh) {
        setData([]);
      }
      setIsLoading(true);
      const result = await getNews({
        tab_id: tabId,
        page: refresh ? 1 : page,
        keywords: search || '',
        pageSize,
        ...(filtersResult || {}),
      });

      if (!result) {
        setIsError(true);
        setIsLoading(false);
        setIsLastPage(true);
        return;
      }
      setData(prev => {
        if (refresh) {
          return result?.data || [];
        } else {
          return [...prev, ...(result?.data || [])].filter(
            (value, index, self) => {
              return (
                self.findIndex(obj =>
                  ['id'].every(key => obj[key] === value[key]),
                ) === index
              );
            },
          );
        }
      });

      setPage(prev => (refresh ? 2 : prev + 1));
      const totalPageCount = Math.ceil(
        parseFloat(result?.total + '' || '2') / pageSize,
      );
      setIsLastPage((refresh ? 1 : page) >= totalPageCount);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadMore(true);
  }, [filtersResult, tabId, currentUser, search]);

  useEffect(() => {
    if (drugDetailsSection) {
      scrollViewRef?.current?.scrollToPosition?.(0, 0, true);
    }
  }, [drugDetailsSection]);

  const initDrugDetails = async () => {
    const drugItem = Object.values(selectedDrug || {})[0] as DrugItemType;
    if (!drugItem) {
      setDrugDetailsData([]);
      setIsDrugDetailsError(false);
      setIsDrugDetailsLoading(false);
      return;
    }

    setIsDrugDetailsLoading(true);
    setIsDrugDetailsError(false);
    const res = await getDrugDetails(drugItem?.id, isDiseases);
    if (!res) {
      setIsDrugDetailsError(true);
      setIsDrugDetailsLoading(false);
      return;
    }
    setDrugDetailsData(res || []);
    setIsDrugDetailsLoading(false);
  };

  useEffect(() => {
    initDrugDetails();
  }, [selectedDrug, tabId, currentUser]);

  const renderHeader = () => {
    return (
      <HeaderContainer headerHeight={headerHeight}>
        <HeaderBackground headerHeight={headerHeight} topInset={topInset} />
        <HeaderContentContainer marginTop={topInset}>
          <BackIcon
            onPress={handleBackPress}
            tintColor={theme.header.primary}
            canGoBack
          />
          {!!search && (
            <SearchOverlay
              pointerEvents={search ? 'auto' : 'none'}
              isVisible={!!search}
              entering={FadeIn}
              exiting={FadeOut}
              onTouchStart={() => {
                Keyboard.dismiss();
                setSearch('');
              }}
            />
          )}
          <HeaderSearchBarContainer>
            <HeaderSearchBar
              style={{opacity: tabFilters === null ? 0.7 : 1, zIndex: 2}}
              textInputStyle={{padding: 0, paddingHorizontal: theme.text.s10}}
              onChangeText={(text: string) => setSearch(text)}
              value={search || ''}
              onTouchStart={() => {
                setIsFilterModalShouldClose(true);
              }}
              hideFocusedEffect
            />
            {(search || '').trim().length > 0 && (
              <SearchContainer
                {...(Platform.OS === 'web'
                  ? {className: 'screen-fade-in-up'}
                  : {entering: FadeInUp, exiting: FadeOutUp})}>
                <SearchContentContainer>
                  <FlatList
                    contentContainerStyle={{
                      flexGrow: 1,
                      paddingVertical: '5%',
                    }}
                    data={data || []}
                    ListEmptyComponent={_renderEmpty}
                    ListFooterComponent={_renderFooter}
                    onEndReachedThreshold={1}
                    onEndReached={() => loadMore()}
                    indicatorStyle={'black'}
                    refreshControl={
                      <RefreshControl
                        tintColor={theme.secondary}
                        refreshing={!!isLoading && data?.length === 0}
                        onRefresh={() => loadMore(true)}
                      />
                    }
                    renderItem={({item}) => {
                      const value = Object.values(
                        selectedDrugSearch || {},
                      )[0] as any;

                      const isSelected = value?.id === item?.id;
                      return (
                        <SearchResultItem
                          onPress={() => {
                            const letter = (item?.name || '')
                              .slice(1)
                              .toUpperCase();
                            if (letter) {
                              setSelectedDrugSearch({[letter]: item});
                            }
                          }}
                          isSelected={isSelected}>
                          <SearchResultText isSelected={isSelected}>
                            {item?.name || ''}
                          </SearchResultText>
                        </SearchResultItem>
                      );
                    }}
                  />
                  <ConfirmSelection
                    onPress={() => {
                      setSelectedDrug(selectedDrugSearch);
                      setSearch('');
                    }}
                    disabled={
                      !selectedDrugSearch ||
                      // @ts-ignore
                      Object.values(selectedDrug || {})[0]?.id ===
                      // @ts-ignore
                      Object.values(selectedDrugSearch || {})[0]?.id
                    }
                    dynamicWidth
                    outline
                    isLabelGradient
                    radius={100}
                    labelStyle={{
                      fontFamily: getFontFamily().regular,
                      paddingLeft: theme.text.s6,
                    }}
                    style={{
                      opacity:
                        !selectedDrugSearch ||
                        // @ts-ignore
                        Object.values(selectedDrug || {})[0]?.id ===
                        // @ts-ignore
                        Object.values(selectedDrugSearch || {})[0]?.id
                          ? 0.4
                          : 1,
                    }}
                    isSmall
                    label={tr('drugs.confirmSelection')}
                    showRightIcon
                    rightIconName={'keyboard-arrow-right'}
                    rightIconType={'MaterialIcons'}
                    rightIconSize={theme.text.s5}
                    rightIconColor={theme.text.dark}
                    rightIconContainerStyle={{position: 'relative'}}
                  />
                </SearchContentContainer>
              </SearchContainer>
            )}
          </HeaderSearchBarContainer>
          <MenuIcon tintColor={theme.header.primary} canGoBack />
        </HeaderContentContainer>
      </HeaderContainer>
    );
  };

  useLayoutEffect(() => {
    navigation?.setOptions({
      header: renderHeader,
    });
  }, [
    filtersResult,
    tabId,
    currentUser,
    tabFilters,
    data,
    selectedDrugSearch,
    isLoading,
    isError,
    loadMore,
    page,
    isLastPage,
    selectedDrug,
    isFilterModalShouldClose,
  ]);

  const _renderFilterItem = (item: FilterType) => {
    if (Object.values(selectedDrug || {}).length > 0) {
      return null;
    }
    return (
      <FilterItemContainer exiting={FadeOut} key={item?.key}>
        <FilterLabel semiBold>
          {`Find ${isDiseases ? 'Diseases' : 'Drugs'} by Alphabet` ||
            item?.label ||
            ''}
        </FilterLabel>
        <FilterValuesContainer>
          {(item?.items || []).map(filterItem => (
            <DrugFilterItem
              setScrollEnabled={setScrollEnabled}
              key={filterItem?.id}
              name={filterItem?.value}
              isSkeleton={item?.static}
              data={data || []}
              onPress={() => {
                setIsFilterModalShouldClose(false);
                if (item.key) {
                  setFiltersResult({[item.key]: filterItem.id});
                }
              }}
              onConfirmSelection={selectedItem => {
                setSelectedDrug(selectedItem);
              }}
              selectedDrug={selectedDrug}
              isLoading={isLoading}
              isError={isError}
              onRefreshPress={() => loadMore(true)}
              onEndReached={() => loadMore()}
              isFilterModalShouldClose={isFilterModalShouldClose}
            />
          ))}
        </FilterValuesContainer>
      </FilterItemContainer>
    );
  };

  const _renderDrugDetailsItem = (item: DrugItemDetailsType, index: number) => {
    return (
      <GenioLatestNews
        // index={index}
        key={item?.section_name || index}
        // image={item?.img_url || ''}
        title={item?.section_name || ''}
        // specialty={item?.specialty || ''}
        onPress={() => {
          setDrugDetailsSection({...item, index});
        }}
        isSmall
        style={{
          width: '100%',
          marginVertical: '2%',
        }}
      />
    );
  };

  const _renderFooter = () => (
    <View
      style={{
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        marginVertical: '5%',
      }}>
      {isLoading && (data || []).length > 0 && <Loader color={theme.primary} />}
    </View>
  );

  const _renderEmpty = () =>
    isError ? (
      <EmptyContainer>
        <EmptyList
          iconName={'alert'}
          iconColor={theme.primary}
          iconSize={theme.text.s1 * 1.5}
          onRefreshPress={() => loadMore(true)}
          title={'app.error'}
          showRefresh
        />
      </EmptyContainer>
    ) : isLoading ? (
      <DrugSearchListSkeleton />
    ) : (
      <EmptyContainer>
        <View>
          <Icon
            name={'empty'}
            size={theme.text.s1 * 1.5}
            color={theme.primary}
          />
        </View>
        <EmptyText semiBold>{tr('app.empty')}</EmptyText>
      </EmptyContainer>
    );

  const _renderDrugDetails = () => {
    const drugItem = Object.values(selectedDrug || {})[0] as DrugItemType;
    if (Object.values(selectedDrug || {}).length === 0) {
      return null;
    }
    return (
      <DrugDetailsContainer>
        <CloseDrugsIconContainer onPress={() => setSelectedDrug({})}>
          <Icon
            name={'close'}
            color={theme.text.grey}
            size={theme.text.s55}
          />
        </CloseDrugsIconContainer>
        {drugItem?.name && (
          <FilterLabel semiBold>
            <FilterLabel bold style={{color: theme.primary}}>
              {`${drugItem?.name || 'Drug'}`}
            </FilterLabel>
            {' OverView'}
          </FilterLabel>
        )}
        <Animated.View
          entering={FadeIn}
          style={{flex: 1, width: '100%', paddingBottom: '5%'}}>
          {isDrugDetailsError
            ? null
            : isDrugDetailsLoading
              ? Array(14)
                .fill({})
                .map((item, index) => {
                  return (
                    <SkeletonPlaceholder
                      key={index}
                      width={'100%'}
                      height={hdp(5)}
                      marginTop={'1%'}
                      marginRight={'1%'}
                      marginBottom={'1%'}
                      marginLeft={'1%'}
                      borderRadius={8}
                    />
                  );
                })
              : (drugDetailsData || []).map(_renderDrugDetailsItem)}
        </Animated.View>
      </DrugDetailsContainer>
    );
  };
  // recording

  useFocusEffect(
    useCallback(() => {
      userVoice?.stop();
      Voice.onSpeechResults = onSpeechResults;
      Voice.onSpeechEnd = stopListening;
      Voice.onSpeechError = onSpeechError;
      return () => {
        Voice?.destroy();
        userVoice?.stop();
        stopListening();
        setDrugDetailsSection(null);
        setQuestion('');
        const timeSpent = entryTime
          ? (new Date().getTime() - entryTime?.current?.getTime()) / 1000
          : 0;

        analyticsService?.logEvent(AnalyticsEvents.OpenTab, {
          tabId,
          tabName,
          timeSpent,
        });
      };
    }, []),
  );

  // useEffect(() => {
  //   if (isError) {
  //     onResetPress(true);
  //   }
  // }, [isError]);
  /**
   * Starts listening for voice input from the user.
   * It sets the recording state to true and initiates the voice recognition process
   * with the specified locale, defaulting to 'en-US' if none is provided.
   */
  const startListening = async () => {
    try {
      if (!isTabVoicePlayed) {
        dispatch(setIsTabVoiceInteractionPlayed());
      }
      setIsRecording(true);
      let locale = 'en-US'; // Default locale
      // Custom locale if languageCode and countryCode are set
      if (languageCode && countryCode) {
        locale = `${languageCode}-${countryCode}`;
      }
      // Start the voice recognition with the determined locale
      await Voice.start(locale);
    } catch (err) {
      setIsRecording(false);
      // Log error if in debug mode
    }
  };

  /**
   * Stops listening for voice input and cleans up listeners.
   * It resets the recording state to false and stops the voice recognition process.
   */
  const stopListening = async () => {
    try {
      await Voice.stop(); // Stop the voice recognition
      Voice.removeAllListeners(); // Remove all attached listeners to clean up
      setIsRecording(false); // Reset the recording state
    } catch (err) {
      // Log error if in debug mode
    }
  };

  /**
   * Handles the event when speech recognition results are obtained.
   * It updates the state with the first recognized speech result.
   *
   * @param {SpeechResultsEvent} event - The event object containing speech recognition results.
   */
  const onSpeechResults = (event: SpeechResultsEvent) => {
    // Update state with the first speech result or an empty string if no results
    setQuestion(
      event && event.value && event?.value?.length > 0 ? event?.value[0] : '',
    );
  };

  /**
   * Handles errors that occur during the speech recognition process.
   * Logs the error details if debug mode is enabled.
   *
   * @param {SpeechErrorEvent} event - The event object containing details about the speech recognition error.
   */
  const onSpeechError = (event: SpeechErrorEvent) => {
    // Log the error details if in debug mode
    setIsRecording(false);
  };

  const onRecordHandler = async () => {
    const permissionGranted = await requestMicrophonePermission();
    if (!permissionGranted) {
      return;
    }
    if (isRecording) {
      userVoice?.stop();
      stopListening();
    } else {
      if (isTabVoicePlayed) {
        startListening();
      } else {
        userVoice?.play(() => startListening());
      }
    }
  };

  const onCheckAnswerPressed = async () => {
    resetChat();
    userVoice?.stop();
    stopListening();
    setQuestion('');
    sendMessage({question, type: ChatType.QNA});
    navigation?.navigate(screens.content.genioChatRoutes, {
      screen: screens.content.genioChat,
    });
    setQuestion('');
  };

  return (
    <>
      <CircleRecordingView
        isRecording={isRecording}
      />
      <MainLayout
        backHeader
        overlayColor={theme.homeBackground + '99'}
        enableScroll={false}
        noPadding>
        <Container>
          <ContentContainer
            nestedScrollEnabled
            ref={scrollViewRef}
            extraScrollHeight={hdp(5)}
            enableOnAndroid={false}
            contentContainerStyle={{
              flexGrow: 1,
            }}
            scrollEnabled
            keyboardShouldPersistTaps="handled">
            {!drugDetailsSection && (
              <FiltersContainer
                {...(Platform.OS === 'web'
                  ? {className: 'screen-fade-in-up'}
                  : {entering: FadeInUp, exiting: FadeOutUp})}>
                {Object.values(tabFilters || {}).map(_renderFilterItem)}
                {_renderDrugDetails()}
              </FiltersContainer>
            )}
            {drugDetailsSection && (
              <DrugDetailsFragment entering={FadeInDown} exiting={FadeOutDown}>
                <DrugItem
                  name={drugDetailsSection?.section_name || ''}
                  style={{
                    marginTop: -hdp(4),
                    marginBottom: '5%',
                    width: 'auto',
                    alignSelf: 'center',
                  }}
                  borderRadius={100}
                  isDynamicRatio
                />
                <CloseAnswerIconContainer>
                  <Icon
                    name={'close'}
                    size={theme.text.s5}
                    role={'button'}
                    color={theme.text.grey}
                    onPress={() => setDrugDetailsSection(null)}
                  />
                </CloseAnswerIconContainer>
                <Markdown
                  rules={markdownRules(theme)}
                  style={{
                    ...markdownStyle(theme),
                    body: {
                      color: theme.text.dark,
                      fontFamily:
                        Platform.OS === 'ios'
                          ? getFontFamily().regular
                          : undefined,
                      fontSize:
                        Platform.OS === 'ios'
                          ? theme.text.s6
                          : theme.text.s6 + 1,
                      zIndex: 2,
                      width: wdp(85),
                    },
                  }}
                  onLinkPress={openMDLink}>
                  {cleanAndFormatMarkdown(drugDetailsSection?.value || '')}
                </Markdown>
              </DrugDetailsFragment>
            )}
            <AnswerItem
              style={{marginTop: '4%', display: answer ? 'flex' : 'none'}}
              onClosePressed={() => setAnswer('')}
              content={answer || ''}
            />
            <ChatFooter
              value={question}
              onChangeText={e => setQuestion(e)}
              onAttachPress={onRecordHandler}
              isAttachBadge={isRecording}
              placeholder={tr('chat.sendPlaceholder')}
              onSubmit={onCheckAnswerPressed}
              isRecording={isRecording}
              hideAnimation
              style={{
                marginTop: '4%',
                paddingBottom: 0,
              }}
            />
            <GenericButton
              label={tr('latest.disclaimer')}
              onPress={() => {
                setIsTipVisible(true);
              }}
              outline
              isSmall
              style={{
                marginVertical: '5%',
                marginHorizontal: wdp(3),
                alignSelf: 'flex-end',
                width: '50%',
              }}
              showRightIcon
              rightIconType={'MaterialCommunityIcons'}
              rightIconName={'information-variant'}
              rightIconSize={theme.text.s55}
            />
            <TibButton
              isVisible={isTipVisible}
              onDismiss={() => setIsTipVisible(false)}
              tipText={tr('drugs.tip')}
            />
            <Space bottomInset={bottomInset} extraSpace={hdp(14)} />
          </ContentContainer>
        </Container>
      </MainLayout>
    </>
  );
};
const mapStateToProps = (state: RootState) => {
  return {
    lang: state.lang,
    auth: state.auth,
    settings: state.settings,
  };
};
export default connect(mapStateToProps, null)(Drugs);
